// extracted by mini-css-extract-plugin
export default {"root":"PageLayout_root__WnZVs","space":"PageLayout_space__Ur4XR"};